module.exports = __webpack_public_path__ + "static/media/url.17452809.svg";